import { useQuery } from '@apollo/client';
import { Container, Link, LoadingOrError } from '@custom/dx3';
import dayjs from 'dayjs';
import DOMpurify from 'dompurify';
import { useMemo } from 'react';
import { useParams } from 'react-router';

import { COPY as ALL_COPY } from '../../assets/copy/copy';
import { LeftArrow } from '../../assets/svgs';
import ROUTES from '../../routes/routes';
import { GET_ARTICLE_DATA } from '../../store/queries/containerQueries';
import { ISODateToDate } from '../../utils/formatters';
import styles from './ArticleContainerStyles.module.scss';

const COPY = ALL_COPY.ARTICLES;

export function ArticleContainer(): JSX.Element {
  const { id } = useParams<{ id: string }>();

  const articleQuery = useQuery(GET_ARTICLE_DATA, {
    variables: {
      articleId: id ?? '',
    },
  });

  const article = useMemo(() => {
    return articleQuery?.data?.me?.article;
  }, [articleQuery]);

  const sanitizedContent = useMemo(() => {
    return (
      article &&
      article.contentHTML &&
      DOMpurify.sanitize(article.contentHTML, { ADD_ATTR: ['target'] })
    );
  }, [article]);

  const startDate = useMemo(() => {
    return article?.startDate ? dayjs(ISODateToDate(article.startDate)) : null;
  }, [article]);

  return (
    <Container
      className={styles['article-container']}
      style={{ marginBottom: '5rem' }}
    >
      <Link href={ROUTES.HOME} className={styles['back-link']}>
        <LeftArrow />
        {COPY.BACK}
      </Link>
      <LoadingOrError loading={articleQuery.loading} error={articleQuery.error}>
        {article?.mainImageUrl && (
          <div className={styles['image-container']}>
            <img
              src={article.mainImageUrl}
              alt={article.mainImageAltText ?? ''}
            />
          </div>
        )}
        {startDate && (
          <p className={styles['date-display']}>
            {startDate.format('MM/DD/YYYY')}
          </p>
        )}
        {article?.title && <h1>{article.title}</h1>}
        {sanitizedContent && (
          <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
        )}
      </LoadingOrError>
    </Container>
  );
}
